export default {
  ClassRoom: {
    Title: 'Lớp học',
    Class: 'Lớp',
    CreateAddClass: 'Tạo lớp học thêm',
    JoinMainClass: 'Tham gia lớp chính quy',
    CreateNewClass: 'Tạo lớp mới',
    ClassName: 'Tên lớp',
    ClassInformation: 'Thông tin lớp học',
    TeacherName: 'Giáo viên',
    OrganizationName: 'Trường',
    GradeName: 'Khối',
    Subject: 'Môn học',
    Description: 'Mô tả',
    Grade: 'Khối',
    PrivateClass: 'Lớp riêng',
    ClassIsAssigned: 'Lớp được phân công',
    OpenNewClass: 'Mở thêm lớp',
    ClassList: 'Danh sách lớp học',
    ClassCode: 'Mã lớp',
    DeleteClass: 'Xóa',
    EditInformationClass: 'Chỉnh sửa thông tin lớp',
    SendByZalo: 'Chia sẻ qua Zalo',
    SendByFacebookMessenger: 'Chia sẻ qua Facebook Messenger',
    CopyClassCode: 'Sao chép mã lớp',
    YouAreManaging: 'Bạn đang quản lý',
    ImageOfClass: 'Ảnh đại diện lớp',
    AutoLockClassWhenFullStudent: 'Tự động khóa lớp khi sĩ số đủ',
    TurnOnAcceptStudentToClass: 'Bật phê duyệt học sinh vào lớp',
    MessageEmptyFormalClassRoom: 'Vui lòng liên hệ cán bộ của trường để phân công lớp học chính quy cho bạn',
    MessageEmptyAddClassRoom: 'Bạn chưa có lớp học thêm nào trong danh sách, nhấn <b>Tạo lớp học thêm</b> để bắt đầu nhé',
    GradeSubject: 'Khối - Môn',
    ChoseGrade: 'Chọn khối',
    ChoseSubject: 'Chọn môn học',
    SubjectExam: ' Môn',
    EnterDescription: 'Nhập mô tả (không bắt buộc)',
    ViewClassDetail: 'Xem chi tiết lớp',
    Warning: 'Cảnh báo',
    ConfirmUnfollow: '',
    MessageUnfollow: 'Bạn có chắc chắn muốn ngừng theo dõi <b>lớp {entityName}</b>? <br/><b>Lớp {entityName}</b> sẽ được chuyển về <span style="color: #8A6BF6; font-weight: bold">Lớp ngừng theo dõi</span>',
    MessageLeaveClass: 'Bạn có chắc chắn muốn rời <b>lớp {entityName}</b> không?',
    Unfollow: 'Ngừng theo dõi',
    Follow: 'Bỏ ngừng theo dõi',
    ListManageClass: 'Danh sách lớp đang quản lý',
    ListStorageClass: 'Danh sách ngừng theo dõi',
    Page: 'Trang',
    StorageClass: 'Xem lớp ngừng theo dõi ',
    JoinClass: 'Vào lớp',
    ClassRoomInformation: 'Thông tin lớp học',
    School: 'Trường',
    MessageEmptyInactiveClassroom: 'Bạn chưa có lớp nào trong danh sách ngừng theo dõi!',
    ShowDetailClass: 'Xem chi tiết lớp',
    Search: 'Tìm kiếm',
    ChangeAvatar: 'Thay ảnh đại diện',
    HaveNotFormalClassroom: 'Chưa có lớp học chính quy',
    HaveNotAddClassroom: 'Chưa có lớp học thêm',
    HaveNotClassroom: 'Chưa có lớp học',
    MessageWarningDeleteClassroom: 'Lớp học bị xóa sẽ không thể khôi phục dữ liệu.<br/>',
    ConfirmDeleteClassroom: 'Bạn có chắc chắn muốn xóa lớp <b>{entity}</b> khỏi danh sách?',
    DeleteClassroomSuccess: 'Xóa lớp thành công',
    TitleAvaiableClassroom: 'Sử dụng lớp đã tạo sẵn',
    MessageAvaiableClassroom: '<b>{schoolName}</b> đã tạo lớp <b>{classNames}</b>. Bạn có muốn sử dụng ngay không?',
    SendInviteClass: 'Gửi lời mời tham gia',
    SendClassCode: 'Gửi mã lớp',
    SendInvite: 'Gửi lời mời',
    SendInviteTitle: 'Gửi lời mời tham gia lớp cho Phụ huynh/Học sinh',
    PleaseChoseClassToInvite: 'Vui lòng chọn lớp muốn gửi lời mời:',
    SendClassCodeTitle: 'Gửi mã lớp cho Phụ huynh/Học sinh',
    SendInviteSubtitle: 'Sao chép nội dung bên dưới rồi gửi vào nhóm trao đổi của lớp',
    ShareSuccessCreateClassroomTitleWay1: '<b>Cách 1</b>: Sao chép nội dung bên dưới rồi gửi vào nhóm trao đổi của lớp',
    ShareClassroomTitleWay1: '<b>Cách 1</b>: Nhấn "Sao chép" và gửi cho học sinh',
    SendInviteZaloTwo: '<b>Cách 2</b>: Chụp mã QR bên dưới hoặc nhấn vào để tải xuống. Gửi vào nhóm trao đổi của lớp, hướng dẫn Phụ Huynh quét mã để tham gia lớp',
    CopyLinkSuccess: 'Đã sao chép đường dẫn',
    OrSendFor: 'Hoặc gửi ngay qua',
    ContentCopyShareSuccessCreateClassroomPopup: 'Vào <a href={linkTo} target="_blank" style="color: #00a9ec">{linkTo}</a> để tham gia lớp {className}  của giáo viên {teacherName}<br/>Mã lớp học: {classCode}',
    ContentCopyShareClassroomPopup: 'Học sinh vào <a href={linkTo} target="_blank" style="color: #00a9ec">{linkTo}</a> để tham gia lớp {className}  của giáo viên {teacherName}<br/>Mã lớp học: {classCode}',
    UserOptionListClassroomDescription: 'Lần đầu tài khoản giáo viên đăng nhập - phục vụ cho việc active tab và show popup sử dụng lớp tạo sẵn',
    UserOptionFirtsEMISAcountLoginDescription: 'Lần đầu tài khoản giáo viên bên hệ thống EMIS đăng nhập',
    CopyContentInviteClass: 'Vào <a href={linkTo} target="_blank"  style="color: #00a9ec">{linkTo}</a> để tham gia lớp {className} của giáo viên {teacherName}',
    ClassInActive: 'Lớp học không còn hoạt động',
    CreateClassroomFinished: 'Đã tạo lớp học thành công!',
    CopyClasscodePopupSubtitle: 'Tạo lớp thành công. Bạn có thể gửi lời mời tham gia lớp cho Phụ huynh/ Học sinh',
    JoinFormalClass: 'Tham gia lớp học chính quy',
    TitleSuggestAvaiableClass: '{schoolName} đã tạo sẵn {count} lớp học cho bạn!',
    TitleSuggestAvaiableClass2: 'Thầy/cô được phân công phụ trách {classCount} lớp học trong năm học {schoolYear}',
    SubtitleSuggestClassByHomeroomTeacher2: 'Căn cứ theo phân công giảng dạy của {schoolName} năm học {schoolYear}, thầy/cô được phân công dạy các lớp như bên dưới. Vui lòng gửi lời mời tham gia lớp cho Phụ huynh/Học sinh hoặc bỏ qua rồi nhấn Hoàn thành để bắt đầu sử dụng.',
    SubtitleSuggestClassByHomeroomTeacher: 'Bạn được phân công dạy các lớp như bên dưới,  nếu bạn là giáo viên chủ nhiệm, vui lòng gửi lời mời tham gia lớp mình phụ trách cho Phụ huynh/Học sinh.',
    SubtitleSuggestClassByNormalTeacher: 'Bạn đang được phân công dạy các lớp như bên dưới. <br>Nhấn Hoàn thành để bắt đầu sử dụng.',
    AssignedClassrooms: 'Danh sách lớp được phân công',
    TitleSendInviteFormalClass: 'Gửi lời mời lớp {classroom}',
    SubtitleSendInviteFormalClass: 'Sao chép nội dung bên dưới rồi gửi cho Phụ huynh/Học sinh.',
    CreateExtraClassroom: 'Tạo lớp học thêm',
    TeachSubject: 'Dạy môn',
    NoTeacher: 'Chưa có giáo viên nào',
    NoFilterTeacher: 'Không tìm thấy giáo viên nào',
    NoteModifyMainClass: 'Lưu ý: Lớp chính quy không thể sửa thông tin Khối, Bộ môn, Tên lớp, không có tính năng Bật phê duyệt học sinh vào lớp',
    SearchTeacher: 'Nhập tên giáo viên để tìm kiếm',
    MessageNotHaveAvailabelClassroom: 'Bạn đã tham gia tất cả các lớp chính quy được phân công.',
    MessageUnassinedTeachClasroom: 'Bạn chưa được phân công giảng dạy cho lớp nào.',
    ConfirmInformationStudent: 'Xác nhận thông tin học sinh',
    FullName: 'Họ tên',
    DateOfBirth: 'Ngày sinh',
    SISAPCode: 'Mã SISAP',
    NotifySISAPCode: 'Vui lòng kiểm tra và nhập mã SISAP cho em <b>{studentName}</b> để xác nhận tham gia lớp học.',
    FillSISAPCode: 'Nhập mã SISAP',
    ManualGetSISAP: 'Vui lòng xóa Học sinh thừa ra khỏi lớp, hướng dẫn Phụ huynh sử dụng <b>Mã SISAP</b> hoặc <b>Số điện thoại</b> để lấy lại tài khoản cũ.',
    ViewDetail: 'Xem hướng dẫn chi tiết',
    NotConfirm: 'Không thể xác nhận do trong lớp đã có em:',
    PhoneNumber: 'Số điện thoại',
    UserOptionFirstUseOTDescription: 'Lần đầu giáo viên đăng nhập hoặc đi từ bên Core sang',
    FormalClass: 'Lớp chính quy',
    AddClass: 'Lớp học thêm',
    SchoolYear: 'Năm học {schoolYearOpen} - {schoolYearClose}',
    LeaveClass: 'Rời khỏi lớp',
    Leave: 'Rời lớp'
  }
}
